import { memo } from "react";
import { Modal } from "@vilocnv/allsetra-core";
import { useTripBackupReminder } from "./useTripBackupReminder";
import { TripBackupReminderModalContent } from "./TripBackupReminderModalContent";
import { useTranslation } from "react-i18next";

export interface TripBackupReminderModalProps {
  accountId: string;
}

export const TripBackupReminderModal = memo(
  ({ accountId }: TripBackupReminderModalProps) => {
    const { open, theme, handleDismiss } = useTripBackupReminder(accountId);

    const { t } = useTranslation();

    if (!open) return null;

    return (
      <Modal
        open={open}
        onClose={handleDismiss}
        theme={theme}
        primaryBtnProps={{
          children: t("tripBackupReminder.dismiss"),
          onClick: handleDismiss
        }}
        secondaryBtnProps={{
          children: t("buttonsText.close"),
          onClick: handleDismiss
        }}
      >
        <TripBackupReminderModalContent />
      </Modal>
    );
  }
);

TripBackupReminderModal.displayName = "TripBackupReminderModal";
